import { computed } from 'vue';

import axios from '@js/clients/axios';
import MESSAGE from '@js/messages';

import { depatternize } from '@formatters/patternize';

import form from '../javascripts/form';
import usePrinter from './printer';

function wrap(i) {
  return Array.isArray(i) ? i : [i];
}

export const SUBMITLESS = '_internal_submit';
export const BYPASS = '_bypass_submit';

const invalidations = window.CREDERE?._INTERNAL?.invalidations;

export default function submitter(
  props,
  planter,

  alert,
  extra,

  emitSuccess,
  emitFailure,
  emitChain,

  toggleButtons,
) {
  const {
    leaves,
    properties,
    errors,
  } = planter;

  const {
    print,
  } = usePrinter(props, planter);

  const singulars = computed(() => wrap(props.singular));
  const plurals = computed(() => wrap(props.plural));
  const endpoints = computed(() => wrap(props.endpoint));
  const identifiers = computed(() => wrap(props.identifier));
  const datas = computed(() => wrap(props.data));

  if (invalidations) {
    singulars
      .value
      .forEach((key, index) => true
        && invalidations[key]
        && print(invalidations[key], key, endpoints.value[index]));
  }

  let chain = [];

  function submit(e, hierarchy, index = 0) {
    e.preventDefault?.();

    alert.value = false;
    extra.value = '';

    toggleButtons(true);

    if (index === 0) {
      chain = [];
    }

    const visible = Object.keys(leaves.value)
      .filter((i) => !properties.value[i].hidden && !properties.value[i].destroyed);

    visible.forEach((i) => planter._COMPOSABLES.invalidate(i));

    if (visible.filter((i) => errors.value[i]).length) {
      MESSAGE.SCROLL();

      alert.value = true;
      extra.value = '';

      toggleButtons(false);

      return;
    }

    function url(_parser, _data, _path) {
      const parsed = _parser(_data, props, planter);

      let key;

      if (datas.value?.[index]) {
        key = datas.value?.[index];
      } else if (props.action === 'list') {
        key = parsed._subparser_plural || plurals.value[index];
      } else {
        key = parsed._subparser_singular || singulars.value[index];
      }

      const { id } = parsed[key] || {};

      let identifier = parsed[key]?.[identifiers.value[index]];

      if (identifier) {
        identifier = /[a-zA-Z]/.test(identifier) ? identifier : depatternize(identifier);
      }

      const action = props.action || (id ? 'update' : 'create');
      const method = action === 'list' ? 'get' : ((id || action === 'update') ? 'put' : 'post'); // eslint-disable-line no-nested-ternary
      const config = _parser.config?.(parsed) || {};

      /* eslint-disable no-param-reassign */
      if (parsed._subparser_endpoint) {
        _path += parsed._subparser_endpoint;
      }

      if (id) {
        _path += `/${identifier}`;
      }
      /* eslint-enable no-param-reassign */

      if (parsed._subparser) {
        return url(_parser.subparser, parsed, _path);
      }

      return {
        key,
        method,
        action,
        parsed,
        config,
        path: _path,
      };
    }

    const {
      key,
      method,
      action,
      parsed,
      config,
      path,
    } = url(
      props.parser,
      form(e.target.form, planter),
      endpoints.value[index],
    );

    const args = [e, hierarchy, action, index, parsed, key];

    singulars.value.concat(plurals.value)
      .filter((i) => i !== key).forEach((i) => delete parsed[i]);

    if (path === SUBMITLESS) {
      success(...[...args, { data: parsed }]);

      return;
    }

    if (path.match(BYPASS)) {
      e.target.closest('form')?.submit();

      return;
    }

    axios[method](
      path,
      method === 'get' ? { params: parsed } : parsed,
      config,
    )
      .then(success.bind(null, ...args))
      .catch(failure.bind(null, ...args))
      .finally(always.bind(null, ...args));
  }

  function success(e, hierarchy, action, index, parsed, key, response) {
    chain.push(response);

    let name = `${key}_${action}`.toUpperCase();
    let message = MESSAGE[name];

    if (!message) {
      name = `${singulars.value[index]}_${action}`.toUpperCase();
      message = MESSAGE[name];
    }

    if (message) {
      message({
        ...response.data,
        settings: {
          hierarchy,
        },
      });
    } else {
      throw new Error(`Mensagem "${key} (${singulars.value[index]}) - ${action}" não encontrada.`.toUpperCase());
    }

    emitSuccess(hierarchy, action, index, parsed, response);

    if (singulars.value[index + 1]) {
      submit(e, hierarchy, index + 1);
    }
  }

  function failure(e, hierarchy, action, index, parsed, key, error) {
    if (error?.response?.status === 422) {
      const details = error?.response?.data?.error?.details || error?.response?.data?.error;

      if (details) {
        print(details, key, endpoints.value[index]);
      }
    }

    alert.value = true;
    extra.value = error?.response?.data?.error?.message || '';

    emitFailure(hierarchy, action, index, parsed, error);

    if (index > 0) {
      let iterating = index;

      while (iterating) {
        iterating -= 1;

        emitChain(hierarchy, action, iterating, parsed, chain[iterating]);
      }
    }
  }

  function always() {
    if (props.action !== 'list') {
      MESSAGE.SCROLL();
    }

    toggleButtons(false);
  }

  return {
    submit,
  };
}
